import React, { Component } from 'react';

class HowItWorks extends Component{
 	render(){
  	return(
    	<div>
        <section className="section first_section not_home grey">
          <div className="section_title">
            <h2 className="mt-0">HOW IT WORKS</h2>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <div className="video_container">
                  <p>
                  It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
     	</div>
  	);
  }
}
export default HowItWorks;